import React from "react";
import { Switch, FormControlLabel } from "@mui/material";

const Toggle = ({ checked, onChange, label, disabled }) => {
  return (
    <FormControlLabel
      control={<Switch checked={checked} onChange={onChange} color="primary" disabled={disabled} />}
      label={label}
    />
  );
};

export default Toggle;
